import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilValue, useRecoilState } from "recoil";
import { userState, indicatorState } from "../../stores/atoms";
import { awsInstance } from "../../actions/api";

function GroupRegister() {
  const [, setIndicator] = useRecoilState(indicatorState);
  const history = useHistory();
  const user = useRecoilValue(userState);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [businessCardId, setBusinessCardId] = useState("");
  const [cardList, setCardList] = useState([]);
  const [limit, setLimit] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    setIndicator("홈 > 그룹 관리 > 그룹 등록");

    const getCardList = async () => {
      try {
        const { data } = await awsInstance.get("/business/card-list", {
          params: {
            id: user.company_id,
          },
        });
        if (data.code === "SUCCESS") {
          setCardList(data.data);
        }
      } catch (e) {
        alert(e);
      }
    };

    getCardList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSelectCard = (event) => {
    const card = event.target.value;
    setBusinessCardId(card);
  };

  const onChangeLimit = (event) => {
    const value = event.target.value;
    setLimit(value.replace(/[^0-9]/g, ""));
  }

  const onSubmitGroup = async (event) => {
    event.preventDefault();
    if (!name) {
      alert("그룹명을 입력해주세요.");
      return false;
    }
    if (!status) {
      alert("상태를 선택해주세요.");
      return false;
    }

    try {
      const { data } = await awsInstance.post("/business/group", {
        company_id: user.company_id,
        name: name,
        description: description,
        business_card_id: businessCardId,
        limit: limit,
        status: status,
      });
      if (data.code === "SUCCESS") {
        alert("성공적으로 등록되었습니다.");
        history.push("/group");
      } else {
        alert(data.message);
      }
    } catch (e) {
      alert(e);
    }
  };

  return (
    <div className="group_register">
      <h5>그룹 등록</h5>
      <div className="display-flex justify-content-between">
        <p className="txt-gray">
          그룹을 등록해 특정 직원들에게만 결제카드 등록, 이용제한 조건 등을
          설정할 수 있습니다.
        </p>
      </div>
      <table className="table table-detail">
        <tbody>
          <tr>
            <th colSpan="1" className="width-20">
              <span>그룹명*</span>
            </th>
            <td colSpan="3" className="width-80 txt-left p-0 pl-2">
              <input
                type="text"
                className="form-control width-30 background-white pl-2"
                maxLength="20"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              ></input>
            </td>
          </tr>
          <tr>
            <th colSpan="1">
              <span>그룹 설명</span>
            </th>
            <td colSpan="3" className="p-0 pl-2">
              <input
                type="text"
                className="form-control background-white width-50 pl-2"
                value={description}
                maxLength="50"
                onChange={(e) => setDescription(e.target.value)}
              ></input>
            </td>
          </tr>
          <tr>
            <th colSpan="1">
              <span>결제수단*</span>
            </th>
            <td colSpan="3" className="txt-left p-0 pl-2">
              <select
                className="form-control width-50 background-white p-1"
                value={businessCardId}
                onChange={onSelectCard}
              >
                <option value="" className="font-bold" key="0">
                  없음
                </option>
                {cardList.length !== 0 &&
                  cardList.map((card) => {
                    return (
                      <option
                        key={card.id}
                        value={card.id}
                        className="font-bold"
                      >
                        {card.nickname}
                        {card.protected_number
                          ? `(${card.protected_number})`
                          : "(세금계산서 발급)"}
                      </option>
                    );
                  })}
              </select>
            </td>
          </tr>
          <tr>
            <th colSpan="1" className="background-light txt-dark-gray">
              <span>개인별 월 이용 한도</span>
            </th>
            <td colSpan="3" className="txt-left p-0 pl-2">
              <div className="d-flex align-items-center pt-1">
                <input
                  type="text"
                  className="form-control background-white width-30 pl-2 mr-2"
                  value={limit}
                  onChange={onChangeLimit}
                  maxLength="11"
                />
              </div>
              <p className="txt-gray my-1">이용 한도 초과시, 해당 직원의 당월 이용이 제한되며 익월부터 사용이 가능합니다.</p>
            </td>
          </tr>
          <tr>
            <th colSpan="1">
              <span>상태*</span>
            </th>
            <td colSpan="3" className="txt-left font-bold">
              <label htmlFor="stateNormal" className="mr-5 mb-0">
                <input
                  type="radio"
                  name="state"
                  id="stateNormal"
                  className="mr-1"
                  checked={status === 100}
                  onChange={() => setStatus(100)}
                ></input>
                정상
              </label>
              <label htmlFor="stateStop" className="mb-0">
                <input
                  type="radio"
                  name="state"
                  id="stateStop"
                  className="mr-1"
                  checked={status === 200}
                  onChange={() => setStatus(200)}
                ></input>
                정지
              </label>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="display-flex justify-content-center">
        <button
          className="btn-white-md mr-4"
          type="button"
          onClick={() => history.goBack()}
        >
          이전
        </button>
        <button className="btn-blue-md" onClick={onSubmitGroup}>
          등록
        </button>
      </div>
    </div>
  );
}

export default GroupRegister;
